import store from '@/store';

function isMaintenanceError(error) {
  return error?.response?.status === 503;
}

export default async function fetchMemberOrganizations() {
  const results = await Promise.allSettled([
    store.dispatch('nationalMemberOrganizations/fetchNMOs'),
    store.dispatch('associateMemberOrganizations/fetchAMOs'),
  ]);

  if (results.some((result) => result.status === 'rejected' && isMaintenanceError(result.reason))) {
    store.dispatch('maintenance/enable');
  }

  return results;
}
